var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgServices(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5458 10.8841L8.99644 14.8771C8.46607 15.4739 7.53375 15.4739 7.00337 14.8771L3.45397 10.8841C3.00493 10.3789 3.00493 9.61761 3.45397 9.11248L7.00337 5.11939C7.53375 4.5227 8.46607 4.5227 8.99644 5.11939L12.5458 9.11248C12.9949 9.61761 12.9949 10.3789 12.5458 10.8841Z",
    stroke: "#2D3643",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 6.24828L11.0035 5.11939C11.5339 4.5227 12.4661 4.5227 12.9965 5.11939L16.5459 9.11248C16.995 9.61761 16.995 10.3789 16.5459 10.8841L12.9965 14.8771C12.4661 15.4739 11.5339 15.4739 11.0035 14.8771L10 13.7483",
    stroke: "#2D3643",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServices);
export default __webpack_public_path__ + "static/media/Services.c080cca7f48d26d4c8091f60edf749b7.svg";
export { ForwardRef as ReactComponent };